import React, {useContext} from 'react';

import {DealersContext} from '../context';

import {Card, CardBody, CardHeader,} from "reactstrap";
import {ButtonContainer} from "@pages/reusable-components/styled-components";

export default function ModulesTab() {
  const dealersContext = useContext(DealersContext);
  const {
    assignedModules,
    modules,
    AllTag,
    updateModules
  } = dealersContext;
  return (
    <Card>
      <CardHeader>
        <h2 className="title">Dealer modules</h2>
      </CardHeader>
      <CardBody>
        {assignedModules && modules && AllTag(modules)}
        <div className="d-flex flex-row justify-content-end">
          <ButtonContainer reverse onClick={() => updateModules()}>Save</ButtonContainer>
        </div>
      </CardBody>
    </Card>
  )
}